export function capitalize(g: string) {
    if (g.length > 0) {
        return g[0].toUpperCase() + g.slice(1);
    }
    return g;
}
